var _excluded = ["kind", "color"],
    _excluded2 = ["compact", "color", "kind"],
    _excluded3 = ["size", "color", "as"],
    _excluded4 = ["kind", "as", "color"],
    _excluded5 = ["color", "as"],
    _excluded6 = ["color"],
    _excluded7 = ["color"],
    _excluded8 = ["color"],
    _excluded9 = ["color"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from "react";
import PropTypes from "prop-types";
import { colorNessieResponsivePropType } from "./propTypes";
import { theme } from "./theme";
import { RAW_cssValue } from "../stylingLib";
import { jsx as _jsx } from "@classdojo/web/nessie/stylingLib/jsx-runtime";
var WEIGHT_EXTRABOLD = 900;
var WEIGHT_BOLD = 700;
var WEIGHT_SEMIBOLD = 600; // const WEIGHT_NORMAL = "400";

var DEFAULT_LINE_HEIGHT = 1.3;
var fontFamily = "ProximaNova, 'Helvetica Neue', Helvetica, Arial, sans-serif"; //----------------------------------------------
//----------------------------------------------
// Base Text Component

var textStyle = {
  borderWidth: 0,
  boxSizing: "border-box",
  color: "inherit",
  fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Ubuntu, "Helvetica Neue", sans-serif',
  fontSize: "14px",
  fontStyle: "inherit",
  fontVariant: "inherit",
  fontWeight: "inherit",
  lineHeight: "inherit",
  margin: 0,
  padding: 0,
  textDecorationLine: "none",
  // block level by default, but inline when nested
  display: "block",
  ">*": {
    display: "inline !important"
  },
  // default wrapping
  whiteSpace: "pre-wrap",
  wordWrap: "break-word"
};
var inlineStyle = {
  display: "inline"
};
var noWrapStyle = {
  maxWidth: "100%",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  ">.text": {
    whiteSpace: "inherit"
  }
}; // Pre compute the class name on evaluation time rather than render time, to make it more performant.

var textAlignStyles = {
  left: {
    textAlign: "left"
  },
  center: {
    textAlign: "center"
  },
  right: {
    textAlign: "right"
  }
};
//
// Primary Text component. All other components build on top of this base text element
//
export var Text = function Text(_ref) {
  var as = _ref.as,
      children = _ref.children,
      href = _ref.href,
      nowrap = _ref.nowrap,
      inline = _ref.inline,
      className = _ref.className,
      textAlign = _ref.textAlign,
      onClick = _ref.onClick,
      _ref$overrides = _ref.overrides,
      overrides = _ref$overrides === void 0 ? {} : _ref$overrides,
      color = _ref.color,
      dataTestName = _ref["data-test-name"],
      ariaLabel = _ref["aria-label"],
      htmlFor = _ref.htmlFor,
      id = _ref.id,
      target = _ref.target,
      role = _ref.role;
  var Tag = typeof href === "string" ? "a" : as || "span";
  var style = {};

  if (overrides.root && overrides.root.style) {
    style = overrides.root.style(theme);
  }

  if (color && theme.colors[color]) {
    style.color = theme.colors[color];
  }

  return _jsx(Tag, {
    "data-test-name": dataTestName,
    href: href,
    target: target,
    onClick: onClick,
    className: "nessie-text ".concat(className),
    "aria-label": ariaLabel,
    htmlFor: htmlFor,
    sx: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, textStyle), textAlign && textAlignStyles[textAlign] || {}), inline && inlineStyle || {}), nowrap && noWrapStyle || {}),
    id: id,
    style: style,
    role: role,
    children: children
  });
};
Text.propTypes = {
  overrides: PropTypes.shape({
    root: PropTypes.shape({
      style: PropTypes.func
    })
  }),
  color: colorNessieResponsivePropType
}; //
// ---------------------------------------
// Text variants
//
// ---------------------------------------
// ---------------------------------------
// Caption

export var Caption = function Caption(_ref2) {
  var _ref2$kind = _ref2.kind,
      kind = _ref2$kind === void 0 ? "normal" : _ref2$kind,
      color = _ref2.color,
      rest = _objectWithoutProperties(_ref2, _excluded);

  return _jsx(Text, _objectSpread(_objectSpread({}, rest), {}, {
    sx: _objectSpread(_objectSpread(_objectSpread({}, captionStyle), captionKindStyles[kind]), color && {
      color: color
    })
  }));
}; // Caption styles

var captionStyle = {
  fontFamily: fontFamily,
  fontSize: 12,
  lineHeight: DEFAULT_LINE_HEIGHT,
  // Font vertical aligment correction
  paddingTop: RAW_cssValue("1.4px"),
  letterSpacing: ".25px",
  fontWeight: WEIGHT_BOLD,
  margin: 0
};
var captionKindStyles = {
  normal: {
    color: "dt_taro90"
  },
  active: {
    color: "dt_aqua50"
  },
  inactive: {
    color: "dt_taro40"
  }
}; // ------------------------------
// ------------------------------
// Action

export var Action = function Action(_ref3) {
  var _ref3$compact = _ref3.compact,
      compact = _ref3$compact === void 0 ? false : _ref3$compact,
      color = _ref3.color,
      _ref3$kind = _ref3.kind,
      kind = _ref3$kind === void 0 ? "available" : _ref3$kind,
      rest = _objectWithoutProperties(_ref3, _excluded2);

  return _jsx(Text, _objectSpread(_objectSpread({}, rest), {}, {
    sx: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, actionStyle), compact && actionCompactStyle || {}), actionKindStyles[kind]), color && {
      "&, &:visited": {
        color: color
      }
    })
  }));
};
var actionStyle = {
  fontFamily: fontFamily,
  fontSize: "18px",
  lineHeight: "22px",
  fontWeight: WEIGHT_BOLD,
  margin: 0
}; // There's no Action Compact in designer's Nessie. Match this to "Detail action"

var actionCompactStyle = {
  fontSize: "15px",
  lineHeight: "18px"
};
var actionKindStyles = {
  available: {
    "&, &:visited": {
      color: "dt_aqua50"
    },
    "&[href]:hover": {
      color: "dt_aqua60"
    }
  },
  unavailable: {
    "&, &:visited": {
      color: "dt_taro30"
    }
  },
  destructive: {
    "&, &:visited": {
      color: "dt_watermelon50"
    },
    "&[href]:hover": {
      color: "dt_watermelon60"
    }
  },
  inactive: {
    "&, &:visited": {
      color: "dt_taro40"
    },
    "&[href]:hover": {
      color: "dt_taro50"
    }
  }
}; // -----------------------------
// -----------------------------
// Title

export var Title = function Title(_ref4) {
  var _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? 1 : _ref4$size,
      color = _ref4.color,
      _ref4$as = _ref4.as,
      as = _ref4$as === void 0 ? "h1" : _ref4$as,
      rest = _objectWithoutProperties(_ref4, _excluded3);

  if (Number(size) < 1 || Number(size) > 4) {
    throw new Error("invalid size attribute passed to Title");
  }

  return _jsx(Text, _objectSpread(_objectSpread({}, rest), {}, {
    as: as,
    sx: _objectSpread(_objectSpread(_objectSpread({}, titleStyle), titleSizeStyles[size]), color && {
      color: color
    })
  }));
};
var titleStyle = {
  fontFamily: fontFamily,
  lineHeight: "1",
  fontWeight: WEIGHT_EXTRABOLD,
  margin: 0,
  color: "dt_taro90"
};
var titleSizeStyles = {
  1: {
    letterSpacing: "-.35px",
    fontSize: "30px",
    lineHeight: "36px"
  },
  2: {
    letterSpacing: "-.5px",
    fontSize: "50px"
  },
  3: {
    letterSpacing: "-.72px",
    fontSize: "72px"
  },
  4: {
    letterSpacing: "-1px",
    fontSize: "102px"
  }
}; // -------------------------------
// -------------------------------
// Heading

export var Heading = function Heading(_ref5) {
  var _ref5$kind = _ref5.kind,
      kind = _ref5$kind === void 0 ? "normal" : _ref5$kind,
      as = _ref5.as,
      color = _ref5.color,
      rest = _objectWithoutProperties(_ref5, _excluded4);

  return _jsx(Text, _objectSpread(_objectSpread({}, rest), {}, {
    as: as,
    sx: _objectSpread(_objectSpread(_objectSpread({}, headingStyle), headingKindStyles[kind]), color && {
      color: color
    })
  }));
};
var headingStyle = {
  fontFamily: fontFamily,
  fontSize: "24px",
  lineHeight: "30px",
  // Font vertical aligment correction
  letterSpacing: "-.25px",
  fontWeight: WEIGHT_EXTRABOLD,
  margin: 0,
  color: "dt_taro90"
};
var headingKindStyles = {
  normal: {
    color: "dt_taro90"
  },
  active: {
    color: "dt_aqua50"
  },
  inactive: {
    color: "dt_taro40"
  }
}; //--------------------------------------
//--------------------------------------
// Subheading

export var Subheading = function Subheading(_ref6) {
  var color = _ref6.color,
      _ref6$as = _ref6.as,
      as = _ref6$as === void 0 ? "h2" : _ref6$as,
      rest = _objectWithoutProperties(_ref6, _excluded5);

  return _jsx(Text, _objectSpread(_objectSpread({}, rest), {}, {
    as: as,
    sx: _objectSpread(_objectSpread({}, subheadingStyle), color && {
      color: color
    })
  }));
};
var subheadingStyle = {
  fontFamily: fontFamily,
  fontSize: "18px",
  lineHeight: "22px",
  fontWeight: WEIGHT_EXTRABOLD,
  margin: 0,
  color: "dt_taro90"
}; //--------------------------------------
//--------------------------------------
// BodyText

export var BodyText = function BodyText(_ref7) {
  var color = _ref7.color,
      rest = _objectWithoutProperties(_ref7, _excluded6);

  return _jsx(Text, _objectSpread(_objectSpread({}, rest), {}, {
    sx: _objectSpread(_objectSpread({}, bodyStyle), color && {
      color: color
    })
  }));
};
var bodyStyle = {
  fontFamily: fontFamily,
  fontSize: 18,
  lineHeight: "22px",
  letterSpacing: "-.25px",
  fontWeight: WEIGHT_SEMIBOLD,
  margin: 0,
  color: "dt_taro90"
}; //--------------------------------------
//--------------------------------------
// DeprecatedDetailText

export var DeprecatedDetailText = function DeprecatedDetailText(props) {
  return _jsx(Text, _objectSpread(_objectSpread({}, props), {}, {
    sx: detailStyle
  }));
};
var detailStyle = {
  fontFamily: fontFamily,
  fontSize: 18,
  lineHeight: DEFAULT_LINE_HEIGHT,
  letterSpacing: "-.25px",
  fontWeight: WEIGHT_SEMIBOLD,
  margin: 0,
  color: "dt_taro40"
}; //--------------------------------------
//--------------------------------------
// DetailText

export var DetailText = function DetailText(_ref8) {
  var color = _ref8.color,
      rest = _objectWithoutProperties(_ref8, _excluded7);

  return _jsx(Text, _objectSpread(_objectSpread({}, rest), {}, {
    sx: _objectSpread(_objectSpread({}, karkDetailStyle), color && {
      color: color
    })
  }));
};
var karkDetailStyle = {
  fontFamily: fontFamily,
  fontSize: "15px",
  lineHeight: "18px",
  fontWeight: WEIGHT_SEMIBOLD,
  margin: 0,
  color: "dt_taro90"
}; //--------------------------------------
//--------------------------------------
// DetailAction

export var DetailAction = function DetailAction(_ref9) {
  var color = _ref9.color,
      rest = _objectWithoutProperties(_ref9, _excluded8);

  return _jsx(Text, _objectSpread(_objectSpread({}, rest), {}, {
    sx: _objectSpread(_objectSpread({}, detailActionStyle), color && {
      color: color
    })
  }));
};
var detailActionStyle = {
  fontFamily: fontFamily,
  fontSize: "15px",
  lineHeight: "18px",
  fontWeight: WEIGHT_BOLD,
  margin: 0,
  color: "dt_taro90"
}; //--------------------------------------
//--------------------------------------
// DetailHeading

export var DetailHeading = function DetailHeading(_ref10) {
  var color = _ref10.color,
      rest = _objectWithoutProperties(_ref10, _excluded9);

  return _jsx(Text, _objectSpread(_objectSpread({}, rest), {}, {
    sx: _objectSpread(_objectSpread({}, detailHeadingStyle), color && {
      color: color
    })
  }));
};
var detailHeadingStyle = {
  fontFamily: fontFamily,
  fontSize: "12px",
  lineHeight: "14px",
  fontWeight: WEIGHT_BOLD,
  letterSpacing: ".5px",
  textTransform: "uppercase",
  margin: 0,
  color: "dt_taro90"
}; // ------------------------------------
// ------------------------------------
// Other text related styles
// ---
// Text field styles

export var textFieldsTextStyles = {
  fontFamily: fontFamily,
  fontSize: 18,
  lineHeight: "22px",
  letterSpacing: "-.25px",
  fontWeight: WEIGHT_SEMIBOLD,
  color: "dt_taro90"
};
//# sourceMappingURL=Text.js.map